import { Moment } from "moment-timezone";

const defaultDateTimeFormat = "L LT";

export const formatDateTime = (dateTime: Moment, timeZone: string) =>
    dateTime?.tz(timeZone)?.format(defaultDateTimeFormat);
